import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToSection() {
  const { pathname } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      let targetId;

      // <-- CHANGEMENT ICI : On gère le cas de la page d'accueil explicitement
      if (pathname === '/') {
        targetId = 'accueil'; // Pour la racine du site, on cible la section "accueil"
      } else {
        targetId = pathname.substring(1); // Pour les autres, on prend le chemin comme ID
      }
      
      const element = document.getElementById(targetId);

      // CAS 1 : On trouve l'élément (y compris "accueil" maintenant).
      if (element) {
        const navbarHeight = 80; // Ajustez cette valeur à la hauteur de votre navbar fixe
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - navbarHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      } 
      // CAS 2 : C'est une nouvelle page (ex: /mentions-legales).
      else {
        // On remonte en haut (comportement pour les pages légales).
        window.scrollTo(0, 0);
      }
    }, 0);

    return () => clearTimeout(timer);

  }, [pathname]);

  return null;
}

export default ScrollToSection;